import { type FC, useMemo } from 'react';
import { useGetContainerType } from '@views/screens/Shipment/hooks';
import type { FormItemProps, SelectProps } from 'antd';
import i18n from 'i18next';

import FormSelectBox from '../../../../components/Inputs/FormSelectBox';

interface ContainerTypeSelectProps extends Pick<FormItemProps, 'rules' | 'name'>, Pick<SelectProps, 'placeholder'> {
  label?: string;
  margin?: string;
  editMode?: boolean;
  onChange?: (value: unknown) => void;
  tooltip?: string;
}

export const ContainerTypeSelect: FC<ContainerTypeSelectProps> = ({
  placeholder = i18n.t('translation:default.fields.refDryIndicator.placeholder'),
  label = i18n.t('translation:default.fields.refDryIndicator.label'),
  rules = [],
  name,
  margin,
  editMode,
  onChange,
  tooltip,
}) => {
  const { data = [], isLoading } = useGetContainerType();

  const options = useMemo(() => [{ label: 'All', value: '*' }, ...data], [data]);

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      tooltip={tooltip}
    />
  );
};
